import produce from 'immer';
import * as types from './types';

const INITIAL_STATE = {
  indicatorsPgData: [],
  errorData: null,
  error: null,
  loading: null,
};

export function indicators(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case types.GET_INDICATORS_PG_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.GET_INDICATORS_PG_SUCCESS: {
        draft.indicatorsPgData = action?.payload?.indicatorsPgData;
        draft.loading = false;
        draft.error = false;
        break;
      }
      case types.GET_INDICATORS_PG_FAILURE: {
        draft.errorData = action?.payload?.errorData;
        draft.loading = false;
        draft.error = true;
        break;
      }

      default:
        return state;
    }
  });
}
